import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Top Level Routes
import Root from './routes/Root';
import ErrorPage from './routes/ErrorPage';

// Route Pages
import About from './routes/About';
import Services from './routes/Services';
import Contact from './routes/Contact';
import Athletes from './routes/Athletes';
import { AuthProvider } from './context/AuthProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import MyAccount from './routes/MyAccount';
import PersistLogin from './components/PersistLogin';

const router = createBrowserRouter([
	{
		path: '/',
		element: <Root />,
		errorElement: <ErrorPage />,
		children: [
			{
				path: '/',
				element: <Services />,
			},
			{
				path: '/about',
				element: <About />,
			},
			{
				path: '/services',
				element: <Services />,
			},
			{
				path: '/contact',
				element: <Contact />,
			},
			{
				path: '/athletes',
				element: <Athletes />,
			},
		],
	},
	{
		path: '/app',
		element: (
			<GoogleOAuthProvider>
				<AuthProvider>
					<PersistLogin>
						<MyAccount />
					</PersistLogin>
				</AuthProvider>
			</GoogleOAuthProvider>
		),
	},
]);

function App() {
	return (
		<>
			<RouterProvider router={router} />
		</>
	);
}

export default App;
